export const DIALOGFLOW_SCRIPT_URL =
  "https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js";

export const STYLE_MARKERS = {
  CHAT_WRAPPER: "data-chat-wrapper-style",
  MESSAGE_LIST: "data-message-list-wrapper-style",
  NESTED_MESSAGE_LIST: "data-nested-message-list-style",
  WELCOME_OVERRIDE: "stewart-welcome-override",
  RESET_BUTTON: "stewart-reset-btn-style",
};

export const CSS_RULES = {
  CHAT_WRAPPER: ".chat-wrapper.expanded { background-color: #ffffff !important; }",
  MESSAGE_LIST: ".message-list-wrapper { border-radius: 0 !important; }",
  WELCOME_OVERRIDE: `
    .content .entry:first-child,
    .entry.stewart-welcome-message,
    .entry:first-child.stewart-welcome-message,
    div.entry:first-child,
    .entry.bot:first-child {
      margin-top: 0 !important;
      margin-block-start: 0 !important;
    }
  `,
  RESET_BUTTON: `
    .stewart-reset-btn,
    button.close-action {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      color: #ffffff;
      padding: 4px;
      border-radius: 6px;
      transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;
      width: 28px;
      height: 28px;
      min-width: 28px;
      margin: 0;
      box-sizing: border-box;
      font-size: 18px;
    }
    .stewart-reset-btn:hover,
    button.close-action:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
    .stewart-reset-btn:active,
    button.close-action:active {
      background-color: rgba(255, 255, 255, 0.25);
    }
    .stewart-reset-btn:focus,
    button.close-action:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
    }
    .stewart-reset-btn:disabled,
    .stewart-reset-btn[aria-disabled="true"] {
      opacity: 0.35;
      cursor: not-allowed;
      pointer-events: none;
    }
    .stewart-reset-btn svg {
      width: 16px;
      height: 16px;
      pointer-events: none;
    }
  `,
};

export const DISCLAIMER_MESSAGE_DEFAULT =
  "You are interacting with an AI tool that generates responses which may sometimes be inaccurate, incomplete, or outdated. You should independently verify any information before relying on the VU Agent's responses and review the VU Sources in the generated response. The VU Agent cannot provide legal, financial or other professional advice, nor replace the need to consult with an underwriter for underwriting advice. Any information the VU Agent provides is for general informational purposes only. Information you enter will be processed in accordance with our Privacy Policy, so please avoid sharing sensitive or confidential information.";

export const WELCOME_GREETING_DEFAULT = "How may I assist you today?";

export const RESET_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M3 21v-5h5"/></svg>`;

export const DEFAULT_CONFIG = {
  PROJECT_ID: "",
  AGENT_ID: "",
  LANGUAGE_CODE: "en",
  MAX_QUERY_LENGTH: "-1",
  CHAT_TITLE: "Ask",
  CHAT_ICON: "",
  DISCLAIMER_MESSAGE: DISCLAIMER_MESSAGE_DEFAULT,
  WELCOME_GREETING: WELCOME_GREETING_DEFAULT,
  OAUTH_CLIENT_ID: "",
  ACCESS_TOKEN: "",
};
